export default "__VITE_ASSET__79b7fb43__"